export default window.BACKEND_VALUES // this comes from RoR
